import { MedicaidDataset } from '@/features/medicaid-datasets';
import { RefreshMedicaidDatasetRequest } from '@/features/medicaid-datasets/types/refresh-medicaid-dataset-request';
import { artiaProtectedApi } from '@/lib/api-client';
import { deleteWithValidation, postWithValidation, RequestOptions } from '@/lib/api-helpers';

import { MedicaidDatasetFormValue } from '../medicaid-dataset-form.provider';

export type CreateMedicaidDatasetRequest = {
  id: string;
};

export const useMedicaidDatasetsService = () => {
  const getMedicaidDatasets = (): Promise<MedicaidDataset[]> => {
    return artiaProtectedApi.get('medicaid/datasets');
  };

  const createMedicaidDataset = ({ id }: MedicaidDatasetFormValue): Promise<any> => {
    const data: CreateMedicaidDatasetRequest = { id };

    const options: RequestOptions<any> = {
      data
    };

    return postWithValidation('medicaid/datasets', options);
  };

  const deleteMedicaidDataset = (id: string): Promise<any> => {
    return deleteWithValidation(`medicaid/datasets/${id}`);
  };

  const refreshMedicaidDataset = (id: string, { importMethod, quarters, states }: RefreshMedicaidDatasetRequest): Promise<any> => {
    return postWithValidation(`medicaid/datasets/${id}/refresh`, {
      data: {
        importMethod,
        quarters,
        states
      }
    });
  };

  return {
    getMedicaidDatasets,
    createMedicaidDataset,
    deleteMedicaidDataset,
    refreshMedicaidDataset
  };
};
